require(`./scss/${process.env.ENTRY_POINT}/product-thumbnail.scss`);

export default require(`./views/${process.env.ENTRY_POINT}/ProductThumbnail`).default;
